import { MARKETING_OFFER_TYPE } from './CommercialSolution';
import { FileProductSummary } from './File';

export interface ProductHistory {
  createdDate: string;
  fileId: string;
  fileReference: string;
  isHistoricalFile: boolean;
  issueId: string;
  reasonId: string;
  stateDate: string;
  stateId: string;
  stateName: string;
  stateShortLabel: string;
  warrantyTypeId: string;
  fileProducts?: FileProductSummary[];
}

export enum ProductType {
  SINGLE_PRODUCT = 'SingleProduct',
  BATCH = 'Batch',
}

export enum PRODUCT_OUTCOME {
  NOT_SET = 'NotSet',
  SWAPPED = 'Swapped',
  REFUNDED = 'Refunded',
  REPAIRED = 'Repaired',
  CANCELLED = 'Cancelled',
}

export interface OutcomeHistory {
  fileId: string;
  externalFileId: string;
  outcome: PRODUCT_OUTCOME;
  outcomeType: MARKETING_OFFER_TYPE;
  date: string;
  downtime: number;
  interventionReportDateUTC: Date;
  irisCode: {
    conditionCode: string;
    symptomCode: string;
    sectionCode: string;
    defectCode: string;
    repairCode: string;
    extendedConditionCode: string;
  };
}
